module.exports = __webpack_public_path__ + "static/fenugreek_seed-32b8abfc3d3f25771dae9d22bc1faa02.png";